<template>
    <v-navigation-drawer
            v-model="changeSidebar"
            class="gr-menu-sidebar"
            temporary
            fixed
            width="290"
    >
        <!-- Capçalera -->
        <div class="gr-side-header pa-4">
            <img class="gr-side-logo" src="@/assets/img/logo-ga-white.svg" alt="Gestoria Riola"/>
            <div class="gr-side-marca">GESTORIA RIOLA</div>
            <div class="gr-side-claim">Tarragona, des del 1935</div>
        </div>

        <v-list nav dense class="pt-2">
            <v-list-item to="/cat" @click="cerrar">
                <v-list-item-icon><v-icon>mdi-home-outline</v-icon></v-list-item-icon>
                <v-list-item-title>Inici</v-list-item-title>
            </v-list-item>

            <!-- ===================== SERVEIS (SILOS) ===================== -->
            <v-subheader class="gr-side-subheader">Serveis</v-subheader>

            <v-list-item
                    v-for="silo in silos"
                    :key="silo.id"
                    :to="silo.url"
                    @click="cerrar"
            >
                <v-list-item-icon><v-icon>{{ silo.icono }}</v-icon></v-list-item-icon>
                <v-list-item-title>{{ silo.titulo }}</v-list-item-title>
            </v-list-item>

            <!-- ===================== CALCULADORES ===================== -->
            <v-subheader class="gr-side-subheader">Calculadores gratuïtes</v-subheader>

            <v-list-item to="/calculadora-itp-cat" @click="cerrar">
                <v-list-item-icon><v-icon>mdi-swap-horizontal</v-icon></v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>Transferència (ITP)</v-list-item-title>
                    <v-list-item-subtitle>Canvi de titularitat</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>

            <v-list-item to="/calculadora-matriculacion-cat" @click="cerrar">
                <v-list-item-icon><v-icon>mdi-car-key</v-icon></v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>Impost de matriculació</v-list-item-title>
                    <v-list-item-subtitle>Cotxes importats · model 576</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>

            <v-divider class="my-2"/>

            <!-- ===================== CONTACTE ===================== -->
            <v-subheader class="gr-side-subheader">Contacte</v-subheader>

            <v-list-item @click="whatsappLink">
                <v-list-item-icon><v-icon color="green darken-1">mdi-whatsapp</v-icon></v-list-item-icon>
                <v-list-item-title>WhatsApp</v-list-item-title>
            </v-list-item>

            <v-list-item @click="phoneLink">
                <v-list-item-icon><v-icon>mdi-phone-outline</v-icon></v-list-item-icon>
                <v-list-item-title>{{ site.telefonoTexto }}</v-list-item-title>
            </v-list-item>

            <v-list-item @click="mailLink">
                <v-list-item-icon><v-icon>mdi-email-outline</v-icon></v-list-item-icon>
                <v-list-item-title>Escriu-nos</v-list-item-title>
            </v-list-item>

            <v-divider class="my-2"/>

            <v-list-item to="/" @click="cerrar">
                <v-list-item-icon><v-icon>mdi-web</v-icon></v-list-item-icon>
                <v-list-item-title>Versión en castellano</v-list-item-title>
            </v-list-item>
        </v-list>

        <template #append>
            <div class="gr-side-pie pa-3">
                <router-link to="/aviso-legal-cat" @click.native="cerrar">Avís legal</router-link>
                <span class="mx-1">·</span>
                <router-link to="/politica-cookies-cat" @click.native="cerrar">Galetes</router-link>
            </div>
        </template>
    </v-navigation-drawer>
</template>

<script>
    import { mapGetters } from 'vuex';
    import contenido from '@/content';

    export default {
        name: "MenuSide",

        data: () => ({
            site: contenido.SITE,
            silos: contenido.navegacionSilos('ca'),
        }),

        computed: {
            ...mapGetters(['collapseSidebar']),
            changeSidebar: {
                get() {
                    return this.$store.state.settings.collapseSidebar
                },
                set(value) {
                    this.$store.commit('collapseSidebarHandler', value)
                }
            }
        },

        methods: {
            cerrar() {
                this.$store.commit('collapseSidebarHandler', false)
            },
            phoneLink() {
                this.cerrar();
                window.open('tel:' + this.site.telefono);
            },
            mailLink() {
                this.cerrar();
                window.open('mailto:' + this.site.email);
            },
            whatsappLink() {
                this.cerrar();
                window.open('https://wa.me/' + this.site.whatsapp + '?text=' +
                    encodeURIComponent('Hola, vull més informació.'));
            }
        },
    }
</script>

<style scoped>
    .gr-side-header {
        background: #900A30;
        color: #fff;
    }

    .gr-side-logo {
        height: 38px;
        width: auto;
        display: block;
        margin-bottom: 8px;
    }

    .gr-side-marca {
        font-weight: 700;
        letter-spacing: 0.04em;
        font-size: 1rem;
        line-height: 1.2;
    }

    .gr-side-claim {
        font-size: 0.75rem;
        opacity: 0.85;
        margin-top: 2px;
    }

    .gr-side-subheader {
        color: #900A30 !important;
        font-weight: 700;
        font-size: 0.72rem;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        height: 30px;
    }

    .gr-side-pie {
        border-top: 1px solid #e7e7e7;
        font-size: 0.72rem;
        text-align: center;
        color: #6b7478;
    }

    .gr-side-pie a {
        color: #6b7478;
        text-decoration: none;
    }

    .gr-side-pie a:hover {
        color: #900A30;
    }
</style>
